// React Dependencies
import React, { useState, useEffect } from 'react';

// External Dependencies
import _ from 'lodash';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';

// Internal Dependencies
import MallNavigationHeader from './MallNavigationHeader';
import ManageLevelsModal from './ManageLevelsModal';
import MallNavigationMap from './MallNavigationMap';
import OverLoading from '../../global/OverLoading';

import { IsEmpty } from '../../../common/checks';
import { Sleep } from '../../../common/util';
import { useMallMapStore } from '../../../hook/useMallMapStore';
import { getPage } from '../../../actions/admin/pageAction';
import apiService from '../../../services.js/apiService';

// eslint-disable-next-line no-shadow
const MallNavigation = ({ match, getPage }) => {
  const pageId = Number(match.params.pageId) || null;
  const yEachMap = useMallMapStore((state) => state.yEachMap);

  const [mallMapData, setMallMapData] = useState([]);
  const [pageData, setPageData] = useState(null);
  const [mallDirectoryList, setMallDirectoryList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isManageLevelModalOpen, setIsManageLevelModalOpen] = useState(false);

  const fetchMallMapData = async () => {
    try {
      setIsLoading(true);
      setMallMapData([]);

      await Sleep(1000);

      const page = await getPage(pageId);
      const data = await apiService.getMallMapsByPageId({ mallPageId: pageId, isReturnWithWaypointAndEdge: true });

      // Get list of mall directories
      const mallDirectories = await apiService.getMallDirectoryByMallPageId(pageId);
      let formattedMallDirectories = [];
      if (!IsEmpty(mallDirectories)) {
        formattedMallDirectories = _.map(mallDirectories, (mallDirectory) => ({ ...mallDirectory, value: mallDirectory.brand, label: mallDirectory.brand }));
        setMallDirectoryList(formattedMallDirectories);
      }

      data.sort((a, b) => a.position - b.position);

      data.forEach((map, index) => {
        map.waypoints = map.waypoints ? map.waypoints : [];
        map.waypoints.forEach((waypoint) => {
          const foundMallDirectory = formattedMallDirectories.find((mallDirectory) => mallDirectory.id === waypoint.mallDirectoryId);

          waypoint.y -= index * yEachMap;
          waypoint.name = !IsEmpty(foundMallDirectory) ? foundMallDirectory.value : '';
        });

        map.edges = map.edges ? map.edges : [];
        map.edges = map.edges.reduce((unique, o) => {
          if (!unique.some((obj) => obj.waypointAId === o.waypointAId && obj.waypointBId === o.waypointBId)) {
            unique.push(o);
          }
          return unique;
        }, []);
      });

      setMallMapData(data);
      setPageData(page);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const openManageLevelModalHandler = () => setIsManageLevelModalOpen(true);
  const closeManageLevelModalHandler = (isDataUpdated = false) => {
    setIsManageLevelModalOpen(false);

    if (isDataUpdated) fetchMallMapData();
  };

  useEffect(() => {
    if (!IsEmpty(pageId)) {
      fetchMallMapData();
    }
  }, []);

  return (
    <div>
      { isLoading && <OverLoading /> }
      { !IsEmpty(pageData) && (
        <MallNavigationHeader
          pageId={pageId}
          pageName={pageData.name}
          mallMapStatus={pageData.mallMapStatus}
          mallMapData={mallMapData}
          onOpenModal={openManageLevelModalHandler}
        />
      )}

      { (!IsEmpty(mallMapData) && !IsEmpty(pageData)) && (
        <>
          <br className="mb-6" />
          <MallNavigationMap
            mallMapData={mallMapData}
            mallDirectoryList={mallDirectoryList}
            setMallMapData={setMallMapData}
            setIsLoading={setIsLoading}
          />
        </>
      ) }

      <ManageLevelsModal
        pageId={pageId}
        isOpen={isManageLevelModalOpen}
        mallMapData={mallMapData}
        onClose={closeManageLevelModalHandler}
      />
    </div>
  );
};

MallNavigation.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      pageId: PropTypes.string.isRequired,
    }),
  }).isRequired,
  getPage: PropTypes.func.isRequired,
};

export default connect(null, { getPage })(MallNavigation);
